import {LanguageSwitcherConfiguration} from "../../app-bootstrap/config-interfaces/b2c-startup.configurations";
import {IServiceFactoryExtended} from "../service-factory-extended.interface";
import {IThemeCustomizer} from "./theme.service.interface";

export class StandardThemeCustomizer implements IThemeCustomizer {
    constructor(protected readonly services: IServiceFactoryExtended) {}
    getHomePageTopBannerHeight(): string {
        if (this.services.homepage.headerArenasStyleIsSmallTiles) {
            if (this.services.mediaQuery.sAndBelow) {
                return "22rem";
            }

            return "29rem";
        }

        if (this.services.mediaQuery.sAndBelow) {
            return "25rem";
        } else if (this.services.mediaQuery.lAndBelow) {
            return "30rem";
        }

        return "47rem";
    }

    getLanguageSwitcherConfigForTestEnvironments(): LanguageSwitcherConfiguration {
        return {
            "languages": [
                {
                    "title": "Deutsch",
                    "url": "https://de.888casino.com/"
                },
                {
                    "title": "Español",
                    "url": "https://es.888casino.com/"
                },
                {
                    "title": "Français",
                    "url": "https://fr.888casino.com/"
                },
                {
                    "title": "日本語",
                    "url": "https://jp.888casino.com/"
                },
                {
                    "title": "Português",
                    "url": "https://br.888casino.com/"
                },
            ],
            "countries": [
                {
                    "title": "Canada",
                    "url": "https://ca.888casino.com/"
                },
                {
                    "title": "España",
                    "url": "https://www.888casino.es"
                },
                {
                    "title": "Danmark",
                    "url": "https://www.888casino.dk"
                },
                {
                    "title": "România",
                    "url": "https://www.888casino.ro"
                },
                {
                    "title": "Italia",
                    "url": "https://www.888casino.it"
                },
                {
                    "title": "Sverige",
                    "url": "https://www.888casino.se"
                },
                {
                    "title": "United States",
                    "url": "https://us.888casino.com"
                },
                {
                    "title": "Portugal",
                    "url": "https://casino.888.pt",
                    "sendFunnelParameters": true
                },
                {
                    "title": "Deutschland",
                    "url": "https://www.888slots.de"
                }
            ],
            "languageSettings": {
                "title": "Choose your language:",
                "current": "English"
            },
            "countrySettings": {
                "title": "Or choose your country:",
                "current": ""
            }
        }
    };
}
